module.exports = __webpack_public_path__ + "static/img/download.284157a4.png";